import { render, staticRenderFns } from "./CreateAccessoryModal.vue?vue&type=template&id=4459b3f8&"
import script from "./CreateAccessoryModal.vue?vue&type=script&lang=ts&"
export * from "./CreateAccessoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4459b3f8')) {
      api.createRecord('4459b3f8', component.options)
    } else {
      api.reload('4459b3f8', component.options)
    }
    module.hot.accept("./CreateAccessoryModal.vue?vue&type=template&id=4459b3f8&", function () {
      api.rerender('4459b3f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accessory/CreateAccessoryModal.vue"
export default component.exports